import { NODE_BUNDLE } from '@commons/pagebuilder/nodes';
import { IS_PRODUCTION } from '@commons/utils/constants';

/**
 * List of bundles to statically generate at build time.
 *
 * Only used in production to limit usage on Vercel.
 */

export const STATIC_PAGE_BUNDLES = IS_PRODUCTION
  ? [NODE_BUNDLE.Page, NODE_BUNDLE.CampaignPage]
  : [];

/**
 * List of bundles that are part of the insights section.
 */

export const INSIGHTS_PAGE_BUNDLES: string[] = [
  NODE_BUNDLE.Article,
  NODE_BUNDLE.PressRelease,
  NODE_BUNDLE.CaseStudy,
  NODE_BUNDLE.Event,
  NODE_BUNDLE.Podcast,
  NODE_BUNDLE.WhitePaper,
  NODE_BUNDLE.Webinar,
];

/**
 * List of bundles that should display the progress bar.
 */

export const BUNDLES_WITH_PROGRESS_BAR: string[] = [NODE_BUNDLE.Article, NODE_BUNDLE.CaseStudy];
